import styled from 'styled-components';

const StyledFoldersNavigationContainer = styled.div`
  flex: 1;
  position: relative;
`;

export { StyledFoldersNavigationContainer };
